<template>
  <v-autocomplete
    id="temas-select"
    v-model="filter.statusSolucao"
    :items="values"
    label="Status"
    placeholder="Selecione..."
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    :clearable="true"
    :return-object="true"
    :rules="rules"
  >
    <template slot="no-data"> Nenhum Status retornado </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "AppEixoCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    defaultValue: {
      type: String | Number,
    },
    filter: {
      type: Object,
      default: () => {
        ({ status: {} });
      },
    },

    disabled: { type: Boolean, default: false },
  },
  watch: {
    defaultValue(value) {
      this.values = value;
    },
  },

  data() {
    return {
      values: ["Previsto", "Em andamento", "Concluído"],
    };
  },
};
</script>
